<div class="invite-link">
  <span class="invite-hint">{{ 'inviteHint' | translate }}</span>
  <div class="invite-url-row">
    <span class="invite-url">{{ registerUrl }}</span>
    <button mat-stroked-button color="primary" (click)="copy()">
      <mat-icon>content_copy</mat-icon>
      {{ (copied ? 'magicLinkCopied' : 'magicLinkClickToCopy') | translate }}
    </button>
  </div>
</div>
